export default [
  {
    title: 'Home',
    route: 'home-agentscout',
    icon: 'HomeIcon',
    action: 'employee',
    resource: 'read',
  },
]
